// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__9wn8t","ltiOpener":"Dashboard_ltiOpener__HX2P5","ltiText":"Dashboard_ltiText__HUt7u","ltiSelectedGame":"Dashboard_ltiSelectedGame__qkFNT"};